import { collection, getDocs, setDoc, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { NOTIFICATIONS_COLLECTION, Notification } from '../../type';

class NotificationService {
  async getAll(): Promise<Notification[]> {
    const q = query(collection(db, NOTIFICATIONS_COLLECTION), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);

    return snapshot.docs.map(doc => ({ 
      ...doc.data(),
      notificationId: doc.id 
    } as Notification));
  }

  async create(notification: Notification): Promise<void> {
    await setDoc(doc(db, NOTIFICATIONS_COLLECTION, notification.notificationId), notification);
  }

  async delete(notificationId: string): Promise<void> {
    await deleteDoc(doc(db, NOTIFICATIONS_COLLECTION, notificationId));
  }
}

export const notificationService = new NotificationService(); 